// extracted by mini-css-extract-plugin
module.exports = {"section":"Content_section__3dGlZ","footer":"Content_footer__2DiTQ"};